import styles from './DistrictInfo.module.css'
import PropertiesInfo from './PropertiesInfo'
import DistrictMap from '.././maps/DistrictMap'

function DistrictInfo({distrito, onDistrictMapChange, setMapImage}){

    return (
        <div className={styles.districtInfo}>
            <PropertiesInfo distrito={distrito}/>
            <DistrictMap distrito={distrito} onSelectDistrict={onDistrictMapChange} onImageReady={setMapImage}/>
        </div>
    )
}

export default DistrictInfo